import { Box, Button, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import KenLoader from '../../../../../../../Components/KenLoader';
import KenCard from '../../../../../../../global_components/KenCard';
import KenGrid from '../../../../../../../global_components/KenGrid';
import KenInputField from '../../../../../../../global_components/KenInputField';
import {
  getCreateGradeRange,
  postDefualtGradeSetup,
} from '../../../../../../../Utils/apiServices';
import Bargraph from './Bargraph';

import { LineChart } from './LineChart';
//  Add the Colum name

const columnGrad = [
  {
    Header: 'ID',
    accessor: 'id',
    disableGlobalFilter: true,
  },
  {
    Header: 'GRADE POINT',
    accessor: 'cgpa',
    disableGlobalFilter: true,
  },

  {
    Header: 'Marks Range',
    accessor: 'percentile',
    disableGlobalFilter: true,
  },

  {
    Header: 'Letter Grade ',
    accessor: 'grade_name',
    disableGlobalFilter: true,
    // Cell: QuestionPaperCell,
  },
];

const GradingSelection = () => {
  const [objSlider, setObjSlider] = useState();

  const [columnGridAbsolute, setColumnGridAbsolute] = useState(columnGrad);
  const [loading, setLoading] = React.useState(false);

  const handleChangeCgpa = (event, rows, index) => {
    setObjSlider((prevState) => {
      return prevState.map((single, i) => {
        if (i === index) {
          return { ...single, cgpa: event.target.value };
        } else {
          return single;
        }
      });
    });
  };

  const handleChangegardename = (event, rows, index) => {
    setObjSlider((prevState) => {
      return prevState.map((single, i) => {
        if (i === index) {
          return { ...single, grade: event.target.value };
        } else {
          return single;
        }
      });
    });
  };
  const cgpaCell = (rows, i) => {
    return (
      <Box>
        <Grid item xs={12} sm={3}>
          <KenInputField
            name={rows}
            optionalLabel={false}
            value={rows}
            dropdownColor="#ffffff"
            // onChange={(e) => handleChangeCgpa(e, rows, i)}
            style={{ fontSize: 12 }}
          />
        </Grid>
      </Box>
    );
  };

  const cgpaCell1 = (rows, i) => {
    return (
      <Box>
        <Grid item xs={12} sm={3}>
          <KenInputField
            name={rows}
            optionalLabel={false}
            value={rows}
            dropdownColor="#ffffff"
            // onChange={(e) => handleChangegardename(e, rows, i)}
            style={{ fontSize: 12 }}
          />
        </Grid>
      </Box>
    );
  };

  const handleChangeSlider = (e, index) => {
    let valueSlider = e.target.value.split('-');
    const arrData = valueSlider.map((ele) => parseInt(ele));
    if (!Array.isArray(arrData)) {
      return;
    }
    if (true) {
      setObjSlider((prevState) => {
        return prevState.map((single, i) => {
          if (i === index) {
            return { ...single, value: [arrData[0] || 0, arrData[1] || 0] };
          } else {
            return single;
          }
        });
      });
    }
  };

  const dataGrad = objSlider?.map((ele, i) => {
    return {
      id: i + 1,
      percentile: (
        <Grid item xs={12} sm={8}>
          <KenInputField
            optionalLabel={false}
            value={ele.value.join(' - ')}
            onChange={(e, value) => handleChangeSlider(e, i, value, 0)}
            // onBlur={() => handleOnBlur()}
            style={{ fontSize: 12 }}
          />
        </Grid>
      ),
      cgpa: cgpaCell(ele.cgpa, i),
      grade_name: cgpaCell1(ele.grade, i),
    };
  });
  const [dataGridAbsolute, setDataGradAbsolute] = useState(dataGrad);
  const postData = () => {
    const data = objSlider?.map((item) => {
      return {
        recordId: item.id,
        typeOfGrading: 'Absolute',
        letterGrade: item.grade,
        upperPercentageLimit: item.value[0],
        lowerPercentageLimit: item.value[1],
        upperPercentileLimit: null,
        lowerPercentileLimit: null,
      };
    });

    postDefualtGradeSetup(data)
      .then((res) => {
        DefaultGrade();
        console.log('getGradingCourseDetails', res);
      })
      .catch((err) => {
        console.log('Grading Course Details error', err);
      });
  };
  const DefaultGrade = () => {
    setLoading(true);

    getCreateGradeRange().then((res) => {
      setLoading(true);
      const finalData =
        res == null
          ? []
          : res[0]?.gradeRangeWrapper?.map((item, index) => {
              console.log('itemitemitemitemitemitem-----', item);
              // const myArray = item.markRange.split('-');
              const myArray = [item.maximumMark, item.minimumMark];
              return {
                id: item.id,
                value: myArray,
                cgpa: item.gradePoint,
                grade: item.letterGrade,
              };
            });
      setLoading(false);

      setObjSlider(finalData);
    });
  };

  // const DefaultGrade = () => {
  //   getCreateGradeRange().then((res) => {
  //     console.log('resresresresresresresres', res[0].gradeRangeWrapper);
  //     const finalData =
  //       res == null
  //         ? []
  //         : res[0]?.gradeRangeWrapper?.map((item, index) => {
  //             console.log('itemitemitemitemitemitem-----', item);
  //             // const myArray = item.markRange.split('-');
  //             const myArray = [item.maximumMark, item.minimumMark];
  //             return {
  //               id: item.id,
  //               value: myArray,
  //               cgpa: item.gradePoint,
  //               grade: item.letterGrade,
  //             };
  //           });
  //     setObjSlider(finalData);
  //   });
  // };

  useEffect(() => {
    DefaultGrade();
  }, []);
  useEffect(() => {
    // setObjSlider(pre => pre)
    setDataGradAbsolute(dataGrad);
    localStorage.setItem('OBJSLIDER_FOR_ABSOLUTE', JSON.stringify(objSlider));
  }, [objSlider]);

  return (
    <div>
      <Grid container spacing={2}>
        {/* <Grid item xs={12} md={6}> */}
        {/* <LineChart /> */}
        {/* <Bargraph /> */}
        {/* </Grid> */}
        <Grid item xs={12} md={12}>
          <Box>
            <KenCard>
              {' '}
              {loading && <KenLoader />}
              <div>
                <Grid container>
                  <Grid xs={8}>
                    {' '}
                    <div>
                      <b>Grade letters</b>
                    </div>{' '}
                  </Grid>
                </Grid>
                <hr />

                <Grid container>
                  {/* <Grid xs={5}>
                    <LineChart />
                  </Grid> */}
                  <Grid lg={12}>
                    <KenGrid
                      columns={columnGridAbsolute}
                      data={dataGrad}
                      pagination={{ disabled: true }}
                      toolbarDisabled={true}
                      initialState={{
                        hiddenColumns: ['id'],
                      }}
                    />{' '}
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ marginRight: '15px' }}
                      // className={classes.addButton}
                      onClick={() => {
                        postData();
                      }}
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </KenCard>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default GradingSelection;
